// 同意文言詳細
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import { Row, Col } from 'react-bootstrap';
import axios from '../../axios';
import Moment from 'moment';
import { handleBrowserBack } from '../../BrowserBack';
import LoadingModal from '../../molecules/LoadingModal';
import { document_status } from '../../const/CustomerDocument';
import {
  CustomerDocument,
  CustomersDocumentKWANKGM10060A01,
} from '../../types/CustomerDocumentDetail';
import {
  document_init,
  can_approval_status,
} from '../../const/CustomerDocumentDetail';
import { KWANKGM10060A01 } from '../../const/api_modules';
import { CustomerDocumentFileDownload } from './CustomerDocumentFileDownload';

const CustomerDocumentDetail = () => {
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(true);
  // URLパラメータの取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const document_id = url_params.get('id');
  // 詳細画面に表示するデータ
  const [document_detail, setDocumentDetail] = useState<CustomerDocument>();
  // 承認ボタンの表示フラグ
  const [approval_button_visible, setApprovalButtonVisible] = useState(false);
  // ログインユーザIDを取得する
  const node = document.getElementById('customer-document-detail');
  const login_user_id = node?.dataset.login_user_id;

  useEffect(() => {
    // ブラウザバック抑止
    handleBrowserBack();

    requestModule();
  }, []);

  /**
   * APIへリクエストを行う
   */
  const requestModule = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWANKGM10060A01,
        is_json : true,
        reception_id : '',
        reception_cd : null,
        detail : [
          { id: 0, name: 'id', value: document_id },
        ],
      });

      if (!response.data.result) {
        throw({ response: response });
      }

      const data = parseData(response.data.detail.customer_document);

      setDocumentDetail(data);
      visibleApprovalButton(response.data.detail.customer_document);
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * APIレスポンスのdataを分解してstateに格納する
   * @param CustomersDocumentKWANKGM10060A01 data response.data.detail.customers_objectのオブジェクト
   * @returns CustomerDocument Stateにセットするオブジェクト
   */
  const parseData = (data: CustomersDocumentKWANKGM10060A01) => {
    const new_document = document_init;

    new_document.id = data.id;
    new_document.group_name = data.group_name;
    new_document.offices_name = data.offices_name;
    new_document.title = data.title;

    if (data.comment !== null && typeof data.comment !== 'undefined') {
      const jsx_comment: JSX.Element[] = [];
      const splited_comment = data.comment.split('\n');
      splited_comment.map((item, index) => {
        if (index >= 1) {
          jsx_comment.push(<br key={`comment-br-${index}`} />);
        }
        jsx_comment.push(<React.Fragment key={`comment-${index}`}>{item}</React.Fragment>);
      });
      new_document.comment = jsx_comment;
    }

    if (data.file_name !== null && typeof data.file_name !== 'undefined'){
      const jsx_file_name: JSX.Element[] = [];
      jsx_file_name.push(<a className="download" onClick={() => {CustomerDocumentFileDownload(Number(document_id), setIsLoading, true)}} key="file-name">{data.file_name}</a>)
      new_document.file_name = jsx_file_name;
    }

    if (data.user_list !== null && typeof data.user_list !== 'undefined') {
      const jsx_user_list: JSX.Element[] = [];
      data.user_list.map((user, index) => {
        jsx_user_list.push(
          <Row key={`user-list-${index}`}>
            <Col md={2} key={`user-list-${index}-1`}>{user.user_name}</Col>
            <Col key={`user-list-${index}-2`}>{user.email}</Col>
          </Row>
        );
      });
      new_document.user_list = jsx_user_list;
    }

    new_document.start_date = Moment(data.start_date).format('YYYY-MM-DD');
    new_document.end_date = Moment(data.end_date).format('YYYY-MM-DD');
    new_document.create_user_name = data.create_user_name;
    new_document.authorizer_name = data.authorizer_name;
    new_document.status = document_status[data.status];
    new_document.updated_at = Moment(data.updated_at).format('YYYY-MM-DD');

    return new_document;
  };

  /**
   * 承認ボタンの表示フラグを切り替える
   * @param CustomersDocumentKWANKGM10060A01 data response.data.detail.customers_documentのオブジェクト
   */
   const visibleApprovalButton = (data: CustomersDocumentKWANKGM10060A01) => {
    if (
      can_approval_status.includes(Number(data.status)) // ステータスが未承認、または削除承認待ちである
      && login_user_id === String(data.authorizer_id) // ログインユーザが顧客宛文書の承認者である
    ) {
      setApprovalButtonVisible(true);
    } else {
      setApprovalButtonVisible(false);
    }
  }

  return (
    <div className="maintenance">
      <div className="title">顧客宛文書</div>
      <div className="maintenance_container">
        <div className="contents">
          <div className="page-title">顧客宛文書詳細</div>
          {typeof document_detail === 'object' ? (
            <>
              <table className="detail_table">
                <tbody>
                  <tr>
                    <th>JA名</th>
                    <td>{document_detail.group_name}</td>
                  </tr>
                  <tr>
                    <th>店舗名</th>
                    <td>{document_detail.offices_name}</td>
                  </tr>
                  <tr>
                    <th>タイトル</th>
                    <td>{document_detail.title}</td>
                  </tr>
                  <tr>
                    <th>コメント</th>
                    <td>{document_detail.comment}</td>
                  </tr>
                  <tr>
                    <th>ファイル名</th>
                    <td>{document_detail.file_name}</td>
                  </tr>
                  <tr>
                    <th>対象顧客</th>
                    <td>{document_detail.user_list}</td>
                  </tr>
                  <tr>
                    <th>掲載開始日</th>
                    <td>{document_detail.start_date}</td>
                  </tr>
                  <tr>
                    <th>掲載終了日</th>
                    <td>{document_detail.end_date}</td>
                  </tr>
                  <tr>
                    <th>登録者</th>
                    <td>{document_detail.create_user_name}</td>
                  </tr>
                  <tr>
                    <th>承認者</th>
                    <td>{document_detail.authorizer_name}</td>
                  </tr>
                  <tr>
                    <th>ステータス</th>
                    <td>{document_detail.status}</td>
                  </tr>
                  <tr>
                    <th>直近更新日</th>
                    <td>{document_detail.updated_at}</td>
                  </tr>
                </tbody>
              </table>
            </>
          ) : (
            <></>
          )}
        </div>
        <Row className="footer-button-block">
          <Col className="footer-btn">
            <a
              className="btn btn-mini btn-outline-success btn-text-color btn-return"
              href={`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/list`}
            >
              戻る
            </a>
          </Col>
          <Col className="footer-btn">
            <a
              className="btn btn-mini btn-success"
              href={`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/edit?id=${document_id}`}
            >
              編集
            </a>
          </Col>
        </Row>
        <Row className="footer-button-block">
          <Col className="footer-btn"></Col>
          <Col className="footer-btn">
            <a
              className={`btn btn-mini btn-success ${!approval_button_visible && 'button-hidden'}`}
              href={`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/approval/confirm?id=${document_id}`}
            >
              承認
            </a>
          </Col>
        </Row>
      </div>
      <LoadingModal show={is_loading} />
    </div>
  );
};

if (document.getElementById('customer-document-detail')) {
  render(<CustomerDocumentDetail />, document.getElementById('customer-document-detail'));
}
